import React from "react";
import { Button, Space } from "antd";
import { CheckOutlined, ReloadOutlined, DeleteOutlined } from "@ant-design/icons";
import PermissionGuard from "../../../components/auth/PermissionGuard";

export default function AirlineIngestDraftRowActions({ record, onReview, onRetry, onDiscard }) {
    if (record.status === "pending_review") {
        return (
            <Space size="small" className="table-actions">
                <Button type="link" size="small" icon={<CheckOutlined />} onClick={() => onReview(record.id)}>
                    核对
                </Button>
                <PermissionGuard permission="airline_schedule_ingest:write">
                    <Button type="link" size="small" danger icon={<DeleteOutlined />} onClick={() => onDiscard(record.id)}>
                        丢弃
                    </Button>
                </PermissionGuard>
            </Space>
        );
    }
    if (record.status === "failed") {
        return (
            <Space size="small" className="table-actions">
                <PermissionGuard permission="airline_schedule_ingest:write">
                    <Button type="link" size="small" icon={<ReloadOutlined />} onClick={() => onRetry(record.id)}>
                        重试
                    </Button>
                    <Button type="link" size="small" danger icon={<DeleteOutlined />} onClick={() => onDiscard(record.id)}>
                        丢弃
                    </Button>
                </PermissionGuard>
            </Space>
        );
    }
    return (
        <Space size="small" className="table-actions">
            <span style={{ color: "#999" }}>{record.error_message || "识别中"}</span>
        </Space>
    );
}
